export { default as ShareButtonSection } from '../../../product-whole-life/benefit-illustration/components/share-button-section'
